import * as tslib_1 from "tslib";
import InboxRuleClause from './InboxRuleClause';
import addNewClause from '../actions/addNewClause';
import getClauseSectionProperties from '../actions/helpers/getClauseSectionProperties';
import getSectionCompletionStatus from '../actions/helpers/getSectionCompletionStatus';
import hasUsedAllClauseTypesInSection from '../actions/helpers/hasUsedAllClauseTypesInSection';
import setClauseErrorText from '../actions/helpers/setClauseErrorText';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
import setRuleName from '../actions/setRuleName';
import store from '../store/store';
import isValidClause from '../utils/isValidClause';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./InboxRulesSection.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRulesSectionComputedState = /** @class */ (function () {
    function InboxRulesSectionComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", {
        get: function () {
            return getSectionCompletionStatus(this.props.sectionType, this.props.clauseIds);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], InboxRulesSectionComputedState.prototype, "sectionCompletionStatus", null);
    return InboxRulesSectionComputedState;
}());
var InboxRulesSection = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesSection, _super);
    function InboxRulesSection(props) {
        var _this = _super.call(this, props) || this;
        _this.setFocusOnNameField = function (shouldSetFocus) {
            setFocusedClauseId('name', shouldSetFocus);
        };
        _this.validateName = function () {
            setClauseErrorText('name', store.inboxRulesEditState.ruleName.trim().length > 0);
            setFocusedClauseId('name', false);
        };
        _this.computedState = new InboxRulesSectionComputedState(_this.props);
        return _this;
    }
    InboxRulesSection.prototype.render = function () {
        var _this = this;
        var sectionProperties = getClauseSectionProperties(this.props.sectionType);
        var sectionStatus = this.computedState.sectionCompletionStatus;
        var sectionNumberClassName = classNames(styles.sectionNumber, sectionStatus == 2 /* InProgress */ &&
            styles.inProgressSection, sectionStatus == 0 /* Incomplete */ &&
            styles.incompleteSection, sectionStatus == 1 /* Complete */ && styles.completeSection);
        var showAddException = this.props.sectionType == 'action' &&
            store.inboxRulesEditState.exceptionClauseIds.length == 0;
        return (React.createElement("div", { className: styles.sectionContainer },
            React.createElement("div", { className: sectionNumberClassName }, sectionStatus == 1 /* Complete */ ? (React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */, className: styles.sectionCompleteCheckmark })) : (this.props.numStep)),
            React.createElement("div", { className: styles.sectionDetails }, this.props.sectionType === 'name' ? (React.createElement("div", { className: styles.ruleNameContainer },
                React.createElement(TextField, { autoComplete: "off", onFocus: function () { return _this.setFocusOnNameField(true); }, onBlur: this.validateName, value: store.inboxRulesEditState.ruleName, placeholder: 'Name your rule', onChanged: this.onRuleNameInputChanged, errorMessage: store.inboxRulesEditState.clauseErrorTextMap.get('name') }))) : (React.createElement("div", null,
                this.renderSectionHeader(sectionProperties),
                this.getInboxRuleSectionClauses(sectionProperties),
                showAddException && (React.createElement(ActionButton, { className: styles.addAnExceptionButton, onClick: function (evt) {
                        addNewClause('exception', null, null);
                    }, text: strings.options_inboxRules_addExceptionSection })))))));
    };
    InboxRulesSection.prototype.getInboxRuleSectionClauses = function (sectionProperties) {
        var clauseIds = this.props.clauseIds;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var sectionType = this.props.sectionType;
        var inboxRuleClauses = [];
        var lastClauseInSection = clauseIds[clauseIds.length - 1];
        for (var i = 0; i < clauseIds.length; i++) {
            var clauseId = clauseIds[i];
            inboxRuleClauses.push(React.createElement(InboxRuleClause, { key: clauseId, clauseId: clauseId, clauseTypeOptions: clauseTypeOptions, sectionType: sectionType, sectionClauseIds: clauseIds }));
        }
        return (React.createElement("div", { className: styles.inboxRuleClausesContainer },
            inboxRuleClauses,
            this.shouldShowAddNewClause() && (React.createElement(ActionButton, { className: styles.addClause, onClick: function (evt) {
                    // validate the previous clause in the section
                    setClauseErrorText(lastClauseInSection, isValidClause(lastClauseInSection));
                    addNewClause(sectionType, null, null);
                }, text: sectionProperties.addClauseText }))));
    };
    InboxRulesSection.prototype.onRuleNameInputChanged = function (inputText) {
        setRuleName(inputText);
    };
    InboxRulesSection.prototype.shouldShowAddNewClause = function () {
        var clauseIds = this.props.clauseIds;
        var lastClauseInSection = store.inboxRulesEditState.clauseMap.get(clauseIds[clauseIds.length - 1]);
        // only show add clause button if
        // 1) the last clause in the section has a type
        // 2) user hasn't used all possible clause types yet
        return (lastClauseInSection &&
            lastClauseInSection.clauseType &&
            !hasUsedAllClauseTypesInSection(this.props.sectionType));
    };
    InboxRulesSection.prototype.renderSectionHeader = function (sectionProperties) {
        return (React.createElement("div", { className: styles.sectionLabel },
            React.createElement("span", null, sectionProperties.headerText)));
    };
    InboxRulesSection = tslib_1.__decorate([
        observer
    ], InboxRulesSection);
    return InboxRulesSection;
}(React.Component));
export default InboxRulesSection;
//# sourceMappingURL=InboxRulesSection.js.map